<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Application">
    <template v-slot:body>
      <div class="row">
        <div class="col-3" v-for="item in data" :key="item.title">
          <div class="card mb-3 widget-content">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">{{ item.title }}</div>
                <div class="widget-subheading">{{ item.group }}</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-success" @click="downloadFile(item.url)">
                  <i class="ti ti-download"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="iframeUrl">
          <iframe :src="iframeUrl" style="display: none"></iframe>
        </template>
      </div>
    </template>
  </Body>
</template>

<script>
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
export default {
  mixins: [Event],
  components: {
    Header,
    SideBar,
    Body
  },
  data() {
    return {
      iframeUrl: ''
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'application'
    },
    data() {
      return this.store.getter('')
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status != 'success') return
      this.store.commit('', rawData.data)
    },
    downloadFile(url) {
      this.iframeUrl = ''
      setTimeout(() => {
        this.iframeUrl = url
      }, 500)
    }
  }
}
</script>

<style lang="scss">
.widget-numbers {
  cursor: pointer;
}
</style>
